var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import styled from 'styled-components';
var Thumb = function (_a) {
    var size = _a.size, src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b, type = _a.type, count = _a.count;
    var noItemImage = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg");
    var imageOnLoadHandler = function (e) {
        var target = e.currentTarget;
        if (target.className !== 'error') {
            target.className = 'success';
        }
        // 실제 이미지 갯수 1개 이상
        // API에서 받는 이미지 갯수는 0일 때 예외처리
        if (count === 0) {
            if (target.className === 'success') {
                target.style.border = '1px solid #e5e5e5';
                target.style.borderColor = '#418ded';
                target.style.cursor = 'pointer';
            }
        }
        if (size === 700) {
            target.style.cursor = 'pointer';
        }
    };
    var imageOnErrorHandler = function (e) {
        var target = e.currentTarget;
        target.src = noItemImage;
        target.className = 'error';
        if (type && type === 1) {
            var bifSizeImageButton = document.getElementById("image-enlargement");
            if (bifSizeImageButton) {
                bifSizeImageButton.style.pointerEvents = 'none';
            }
        }
    };
    return (React.createElement(Style, { size: size },
        React.createElement("img", { src: src, onLoad: imageOnLoadHandler, onError: imageOnErrorHandler, alt: alt })));
};
// eslint-disable-next-line no-mixed-operators
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    // ", ";\n    ", ";\n    overflow: hidden;\n    background: url(", ");\n    background-size: cover;\n\n    & > img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        -webkit-user-drag: none;\n        transition: opacity 0.2s;\n        z-index: 1;\n        .success {\n            background: url( ", ")\n        }\n        .error {\n            background: url(", ");\n        }\n    }\n"], ["\n    position: relative;\n    // ", ";\n    ", ";\n    overflow: hidden;\n    background: url(", ");\n    background-size: cover;\n\n    & > img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        -webkit-user-drag: none;\n        transition: opacity 0.2s;\n        z-index: 1;\n        .success {\n            background: url( ", ")\n        }\n        .error {\n            background: url(", ");\n        }\n    }\n"])), function (_a) {
    var size = _a.size;
    return (size ? "width: ".concat(size, "px; height: ").concat(size, "px") : "padding-top: 100%");
}, function (_a) {
    var size = _a.size;
    return (size ? (typeof size === 'string' ? "width: ".concat(size, "; height: ").concat(size) : "width: ".concat(size, "px; height: ").concat(size, "px")) : 'padding-top: 100%');
}, "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg"), function (props) { return props.src; }, "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg"));
export default memo(Thumb);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/product/thumb.tsx
// module id = 100
// module chunks = 0